import { icons } from "../../../../../../../utils/icons";
import { Acionamento } from '../../../../../../../types/historico-interface'
import { verifyIcon } from "../../../../../../../utils/verifyIcons";

interface HistoricoCardProps {
  acionamento: Acionamento
}

export const HistoricoCard = ({ acionamento }: HistoricoCardProps) => {

  function getIcon(obs: string) {
    var primeiraPalavra = obs.match(/\w+/) || '';

    return primeiraPalavra[0].toLocaleLowerCase().replace(':', '')
  }

  return (
    <div className="mb-2 mt-4 flex flex-col rounded border border-primary p-2 text-sm">
      <div className="my-2 flex items-center gap-8">
        {/* <div className="ml-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary">
          <img
            src={icons[`${verifyIcon(getIcon(acionamento.observacoes))}`].icons}
            alt=""
            className="h-5 w-5 bg-transparent"
          />
        </div> */}
        <div className=" grid grid-cols-3 text-gray-500">
          <p>
            <strong className="text-gray-600">Data:</strong> {acionamento.datamov}
          </p>
          <p className="mr-4">
            <strong className="text-gray-600">Operador:</strong> {acionamento.cobrador}
          </p>

          <p>
            <strong className="text-gray-600">Acionamento:</strong> {acionamento.tipo}
          </p>
          <p>
            <strong className="text-gray-600">Hora:</strong> {acionamento.horas}
          </p>
          <p>
            <strong className="text-gray-600">Protocolo:</strong> {acionamento.id_poscob}
          </p>
        </div>
      </div>
      <div className="block max-w-5xl rounded-lg border border-gray-200 bg-gray-100 px-4 py-2 shadow-sm  ">
        <strong className="text-sm text-gray-500">
          {acionamento.observacoes}
        </strong>
      </div>
    </div>
  );
};
